import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { S3Service } from '../../service';

export type RequireSslConfig = typeof RequireSslConfig._.Config;

export const RequireSslConfig = IntegrationConfig.make({
  service: S3Service,
  name: Integration_Handler_Names_Enum.RequireSsl,
  configSchema: z.object({
    buckets: z.array(z.string().trim().min(1)).min(1),
  }),
});
